export default __webpack_public_path__ + "media/src/features/home-page-redesign/assets/partnershipIcon-cf41cc8201899d3e24f5a19d9152ce2c.svg";